export const IkeCloneable = {
	ALL: 'all' as const,
	/**
	 * @default
	 */
	NONE: 'none' as const,
	FIRST: 'first' as const,
};

export type IkeCloneable = typeof IkeCloneable.ALL | typeof IkeCloneable.NONE | typeof IkeCloneable.FIRST;
